import React, { useState } from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Container } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqData = [
    {
        question: 'Comment créer un compte sur la plateforme ?',
        answer: 'Pour créer un compte, cliquez sur "S\'inscrire" dans le coin supérieur droit, remplissez les champs nécessaires avec vos informations personnelles, puis validez. Vous recevrez un e-mail de confirmation pour activer votre compte.'
    },
    {
        question: 'Comment ajouter des K-Dramas à ma liste de favoris ?',
        answer: 'Sur la page de chaque K-Drama, vous trouverez un bouton "Ajouter aux favoris". Cliquez dessus pour ajouter le K-Drama à votre liste. Vous pouvez accéder à votre liste depuis votre profil.'
    },
    {
        question: 'Comment puis-je supprimer un K-Drama de ma liste ?',
        answer: 'Allez dans votre liste de favoris, puis cliquez sur l\'icône "Supprimer" à côté du K-Drama que vous souhaitez retirer de votre liste.'
    },
    {
        question: 'La plateforme est-elle gratuite ?',
        answer: 'Oui, notre plateforme propose un accès gratuit à une sélection de K-Dramas.'
    },
    {
        question: 'Comment réinitialiser mon mot de passe ?',
        answer: 'Si vous avez oublié votre mot de passe, cliquez sur "Mot de passe oublié" sur la page de connexion. Suivez les instructions pour réinitialiser votre mot de passe par e-mail.'
    },
    {
        question: 'Quels sont les types de contenu disponibles ?',
        answer: 'Notre plateforme propose une large sélection de K-Dramas, de séries télévisées, et de films, organisés par catégories pour une navigation facile.'
    },
    {
        question: 'Comment contacter le support client ?',
        answer: 'Pour toute question ou assistance, vous pouvez nous contacter à [adresse e-mail] ou utiliser notre formulaire de contact accessible depuis le bas de chaque page.'
    },
    {
        question: 'Quels sont mes droits concernant mes données personnelles ?',
        answer: 'Conformément au RGPD, vous avez le droit d\'accéder, de modifier ou de supprimer vos données personnelles. Rendez-vous dans la section "Paramètres" de votre profil pour gérer vos informations.'
    },
];

const FaqComponent = () => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth="md" sx={{ backgroundColor: '#141414', color: '#fff', padding: '2rem', borderRadius: '10px', marginTop: '2rem' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center' }}>
                Foire Aux Questions (FAQ)
            </Typography>
            {faqData.map((item, index) => (
                <Accordion
                    key={index}
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    sx={{ backgroundColor: '#1e1e1e', color: '#fff', marginBottom: '1rem', borderRadius: '10px' }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{item.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>{item.answer}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Container>
    );
};

export default FaqComponent;
